import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    this.element.addEventListener("turbo:submit-end", this.showRecentlyAdded.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.showRecentlyAdded)
  }

  showRecentlyAdded() {
    if (!document.getElementById('link-add')) {
      document.getElementById('portfolio-tabs')?.insertAdjacentHTML('afterbegin', `<li id="link-add" class="nav-item"> <a class="nav-link" data-bs-toggle="tab" href="#tab-add">Recently Added</a></li>`);
      bootstrap.Tab.getOrCreateInstance(document.querySelector('#portfolio-tabs a[href="#tab-add"]')).show();
    } else {
      bootstrap.Tab.getOrCreateInstance(document.querySelector('a[href="#tab-add"]')).show();
      showTabPortfolio('#tab-add');
    }
  }
}
